import { render, staticRenderFns } from "./button-logout.vue?vue&type=template&id=56401698"
import script from "./button-logout.vue?vue&type=script&lang=js"
export * from "./button-logout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports